import React, {Component} from 'react'
import {Col, Row, DropdownButton, MenuItem} from 'react-bootstrap'
import {MdSettings} from '../Common/ReactIcons/icons'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import UserAvatar from './UserAvatar'
import {LinkContainer} from 'react-router-bootstrap'

import './UserScreen.css'

class UserScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      user: props.user
    }
  }

  componentWillReceiveProps (nextProps) {
    this.setState({user: nextProps.user})
  }

  render () {
    const {user} = this.state
    return (
      <div className="Profile">
        <div className="container">
          <Row className="Wraper">
            <Col lg={3} lgOffset={1} md={4} mdOffset={0} sm={5} smOffset={0} xs={10} xsOffset={1}>
              <Row className="Box">
                {user && <UserAvatar user={user} />}
                <div className="UserAction">
                  <DropdownButton title={<MdSettings className="Settings" />} id="bg-nested-dropdown">
                    <LinkContainer to="/user/change-password">
                      <MenuItem eventKey="1">تغییر رمز عبور</MenuItem>
                    </LinkContainer>
                    <LinkContainer to="/user/profile-edit">
                      <MenuItem eventKey="1">ویرایش پروفایل</MenuItem>
                    </LinkContainer>
                  </DropdownButton>
                  <Link className="btn btn-default editProfileButton" to="/user/profile">پروفایل</Link>
                </div>
              </Row>
            </Col>
            <Col lg={7} md={8} sm={7} smOffset={0} xs={10} xsOffset={1}>
              {this.props.children}
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.currentUser
  }
}
export default connect(mapStateToProps)(UserScreen)



// WEBPACK FOOTER //
// ./src/components/User/UserScreen.js